import styled from "@emotion/styled"
import { colorSurface, radiusMd } from "@porsche-design-system/components-react/emotion"

/** a gray tile for an image that has not been uploaded yet */
export const NewsImagePlaceholderTile = () => <Tile aria-hidden data-testid="news-image-placeholder" />

const Tile = styled.div`
	aspect-ratio: 4 / 3;
	border-radius: ${radiusMd};
	background: ${colorSurface};
`
